import { FC } from 'react';
import { Link } from 'react-router-dom';

import Heading from 'components/_core/Heading';
import * as OfferDetailsLayout from 'layouts/OfferDetailsLayout';

import { OfferWithLink } from '../../types';
import OfferCard from '../OfferCard';
import locales from './locales';

interface SimilarOffersProps {
  offers: OfferWithLink[];
}

const SimilarOffers: FC<SimilarOffersProps> = ({ offers }) => (
  <>
    <Heading paddingBottom="space-24">{locales.title}</Heading>

    <OfferDetailsLayout.ListGrid paddingBottom="0">
      {offers.map((offer) => (
        <OfferCard
          as={Link}
          key={offer.path.pathname}
          offer={offer}
          to={{ ...offer.path, state: { from: 'similar-offers' } }}
        />
      ))}
    </OfferDetailsLayout.ListGrid>
  </>
);

export default SimilarOffers;
